import { inject } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
  UrlSegment,
} from "@angular/router";
import { filter, map, startWith } from "rxjs";

export const pathRouteParametersHelper$ = () => {
  const router = inject(Router);

  return router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null), // Emit immediately for initial load
    map(() => {
      // Start from root and find the deepest child
      let deepestRoute: ActivatedRoute = router.routerState.root;

      while (deepestRoute.firstChild) {
        deepestRoute = deepestRoute.firstChild;
      }

      // Collect all params from root to deepest child
      if (!deepestRoute.snapshot || !deepestRoute.snapshot.pathFromRoot) {
        return {};
      }

      const allParams = Object.assign(
        {},
        ...deepestRoute.snapshot.pathFromRoot.map((r) => r.params),
      );
      return allParams;
    }),
  );
};

export const pathRouteDataHelper$ = () => {
  const router = inject(Router);

  return router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null), // Emit immediately for initial load
    map(() => {
      // Start from root and find the deepest child
      let deepestRoute: ActivatedRoute = router.routerState.root;

      while (deepestRoute.firstChild) {
        deepestRoute = deepestRoute.firstChild;
      }

      // Collect all data from root to deepest child
      if (!deepestRoute.snapshot || !deepestRoute.snapshot.pathFromRoot) {
        return {};
      }

      const allData = Object.assign(
        {},
        ...deepestRoute.snapshot.pathFromRoot.map((r) => r.data),
      );
      return allData;
    }),
  );
};

export const pathParamsHelper = (route: ActivatedRouteSnapshot) => {
  const allParams = Object.assign(
    {},
    ...route.pathFromRoot.map((r) => r.params),
  );

  return {
    get deepPath(): string[] {
      return route.pathFromRoot
        .map((r) => r.url.map((urlParts: UrlSegment) => urlParts.path))
        .flat();
    },

    get productID(): string {
      return allParams["id"];
    },

    get countryID(): string {
      return allParams["country"]?.toUpperCase();
    },

    get languageID(): string {
      return allParams["language"]?.toLowerCase();
    },

    get year(): number {
      return Number(allParams["year"]);
    },

    get docCatID(): string {
      return allParams["docCatId"]?.toLowerCase();
    },

    get productDetailID(): string {
      return allParams["productId"];
    },

    get competitorID(): string {
      return allParams["competitorId"];
    },
  };
};
